import { defineComponent as t, provide as s, reactive as u, toRef as o, openBlock as a, createElementBlock as m, normalizeClass as c, unref as i, renderSlot as l } from "vue";
import { buttonGroupProps as f, buttonGroupContextKey as d } from "./button-group.js";
import "./button-group.css";
import { useNamespace as _ } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
const b = t({
  name: "ApButtonGroup"
}), k = /* @__PURE__ */ t({
  ...b,
  props: f,
  setup(r) {
    const e = r, p = _("btn-group");
    return s(
      d,
      u({
        size: o(e, "size"),
        type: o(e, "type")
      })
    ), (n, v) => (a(), m("div", {
      class: c([i(p).b()])
    }, [
      l(n.$slots, "default")
    ], 2));
  }
});
export {
  k as default
};
